<template>
  <div class="container new-box">
    <div class="header clearfix">
      <div class="login-box">
        <span class="nav-sp">
          <img src="../../assets/images/logo1.jpg" alt="">
          <span>四川广智华荣工程项目咨询有限公司</span>
          <em class="em2">Sichuan Guangzhi Huarong Project Consulting Co., Ltd</em>
          <em>规范，专业，服务，创新</em>
        </span>
        <p class="login-iphone2" v-if="user_id==''">
          <span class="iphone-sp0"><em @click="dialogVisible = true">登录</em>/<em @click="goreg()">注册</em></span>
          <span class="iphone-sp1">咨询电话</span>
          <span class="iphone-sp2">028-61894045</span>
        </p>
        <div class="login-user" v-if="user_id!=''">
          <p class="user-p1"><a href="javascript:;" @click="gobsxt()">标书大厅</a><a href="javascript:;"
              @click="gouser()">报名的项目</a><a href="javascript:;">中标项目</a><a href="javascript:;"
              @click="gologinout">退出登录</a></p>
          <p class="user-p2"><a href="javascript:;" @click="goqyxx()">当前账号</a>：{{user_name}}</p>
          <p class="user-p3"><a href="javascript:;">咨询电话</a><a href="javascript:;">投诉建议</a><a
              href="javascript:;">常见问题</a><a href="javascript:;">标书领取</a></p>
        </div>


      </div>
      <div class="nav">
        <p class="nav-p">
          <a href="javascript:;" @click="goHome()"><span>官方首页</span> </a>
          <a href="javascript:;" @click="goqyjj()"><span>企业简介</span> </a>
          <a href="javascript:;" @click="gozbxx()"><span>招标信息</span> </a>
          <a href="javascript:;" @click="gokffw()"><span>客服服务</span></a>
          <a href="javascript:;" @click="gogsdt()"><span>公司动态</span></a>
          <a href="javascript:;" @click="gojlyd()"><span>交流园地</span></a>
          <a href="javascript:;" @click="gorczp()"><span>人才招聘</span></a>
          <a href="javascript:;" @click="gobsxt()"><span>报名系统</span></a>

        </p>
      </div>
    </div>
    <!--switch-->
    <div class="switch3 clearfix">
      <img src="../../assets/images/bssm-ban.jpg" alt="">
      <div class="search">
        <el-input v-model="input" placeholder="请输入需要搜索的标书名称或者项目编号"></el-input>
        <el-row>
          <el-button>确认搜索</el-button>
        </el-row>
      </div>
    </div>
    <!--switch END-->
    <!--content -->
    <!--center-->
    <div class="center-bsxt clearfix">
      <div class="bsxt2">
        <template v-if="regnumber==0">
          <el-tabs @tab-click="handleClick" v-model="activeName">
            <el-tab-pane label="待付款项目" name="first">
              <div class="list-box2" v-if="bstype==1">
                <p class="bsxt-p2"><span class="span1">领取编号</span><span class="span11">项目名称</span><span
                    class="span2">领取状态</span><span class="span3">服务费</span><span class="span4">领取时间</span><span
                    class="span5">操作</span></p>
                <ul class="bsxt-ul2">
                  <li v-for="(bslistdata,index) in bslistdata1" :key="index">
                    <span class="span1">{{bslistdata.order_sn}}</span>
                    <span class="span11">{{bslistdata.project_name}}</span>
                    <span class="span2" v-if="bslistdata.status==5">待付款</span>
                    <span class="span2" v-if="bslistdata.status==10">已报名</span>
                    <span class="span2" v-if="bslistdata.status==15">待审核</span>
                    <span class="span2" v-if="bslistdata.status==20">已中标</span>
                    <span class="span2" v-if="bslistdata.status==21">未中标</span>
                    <span class="span2" v-if="bslistdata.status==50">已取消</span>
                    <span class="span3">{{bslistdata.tender_service_fee}}</span>
                    <span class="span4">{{bslistdata.create_time}}</span>
                    <span class="span5"><a href="javascript:;" @click="postorderpay(bslistdata.order_id,bslistdata.handler_id)">去支付</a><a
                        href="javascript:;" @click="postorderover(bslistdata.order_id)">取消领取</a></span>
                  </li>
                </ul>
              </div>

            </el-tab-pane>
            <el-tab-pane label="已报名项目" name="second">
              <p class="bsxt-p2"><span class="span1">领取编号</span><span class="span11">项目编号与名称</span><span
                  class="span2">领取状态</span><span class="span3">服务费</span><span class="span4">领取时间</span><span
                  class="span5">操作</span></p>
              <ul class="bsxt-ul2">
                <li v-for="(bslistdata,index) in bslistdata2" :key="index">
                  <span class="span1">{{bslistdata.order_sn}}</span>
                  <span class="span11">{{bslistdata.project_sn}}<br/>{{bslistdata.project_name}}</span>
                  <span class="span2" v-if="bslistdata.status==5">待付款</span>
                  <span class="span2" v-if="bslistdata.status==10">已报名</span>
                  <span class="span2" v-if="bslistdata.status==15">待审核</span>
                  <span class="span2" v-if="bslistdata.status==20">已中标</span>
                  <span class="span2" v-if="bslistdata.status==21">未中标</span>
                  <span class="span2" v-if="bslistdata.status==50">已取消</span>
                  <span class="span3">{{bslistdata.tender_service_fee}}</span>
                  <span class="span4">{{bslistdata.create_time}}</span>
                  <span class="span5">
                    <a class="a2" href="javascript:;" @click="getdownload(bslistdata.file_code)"><em
                        class="em1">领取采购文件</em><em class="em2">{{bslistdata.project.receive_end_at}}截止</em></a>
                    <a class="a2" href="javascript:;" @click="postorderpay2(bslistdata.order_id)"><em
                        class="em1">支付保证金</em><em class="em2">{{bslistdata.project.bond_by_at}}  截止</em></a>
                  </span>
                </li>
              </ul>
            </el-tab-pane>
            <el-tab-pane label="已投标待审核项目" name="third">
              <p class="bsxt-p2"><span class="span1">领取编号</span><span class="span11">项目编号与名称</span><span
                  class="span2">领取状态</span><span class="span3">服务费</span><span class="span4">领取时间</span><span
                  class="span5">操作</span></p>
              <ul class="bsxt-ul2">
                <li v-for="(bslistdata,index) in bslistdata3" :key="index">
                  <span class="span1">{{bslistdata.order_sn}}</span>
                  <span class="span11">{{bslistdata.project_sn}}<br/>{{bslistdata.project_name}}</span>
                  <span class="span2" v-if="bslistdata.status==5">待付款</span>
                  <span class="span2" v-if="bslistdata.status==10">已报名</span>
                  <span class="span2" v-if="bslistdata.status==15">待审核</span>
                  <span class="span2" v-if="bslistdata.status==20">已中标</span>
                  <span class="span2" v-if="bslistdata.status==21">未中标</span>
                  <span class="span2" v-if="bslistdata.status==50">已取消</span>
                  <span class="span3">{{bslistdata.tender_service_fee}}</span>
                  <span class="span4">{{bslistdata.create_time}}</span>
                  <span class="span5">
                    <a class="a2" href="javascript:;" @click="getdownload(bslistdata.file_code)"><em
                        class="em1">领取采购文件</em></a>
                     <a class="a3" href="javascript:;">
                      <el-button size="small" type="primary"    @click="getDocumentsid(bslistdata.order_id)">上传投标文件</el-button>
                      <div slot="tip" class="el-upload__tip" >文件大小控制在50M以内</div>                     </a>
                       <i   v-if="bslistdata.fileupload!=null" class="el-icon-folder">
                         <a href="javascript:;" @click="getdownload(bslistdata.fileupload)">标书文件</a>
                       </i>
                  </span>
                </li>
              </ul>
            </el-tab-pane>
            <el-tab-pane label="中标/领取通知书" name="fourth">
              <p class="bsxt-p2"><span class="span1">领取编号</span><span class="span11">项目名称</span><span
                  class="span2">领取状态</span><span class="span3">服务费</span><span class="span4">领取时间</span><span
                  class="span5">操作</span></p>
              <ul class="bsxt-ul2">
                <li v-for="(bslistdata,index) in bslistdata4" :key="index">
                  <span class="span1">{{bslistdata.order_sn}}</span>
                  <span class="span11">{{bslistdata.project_name}}</span>
                  <span class="span2" v-if="bslistdata.status==5">待付款</span>
                  <span class="span2" v-if="bslistdata.status==10">已报名</span>
                  <span class="span2" v-if="bslistdata.status==15">待审核</span>
                  <span class="span2" v-if="bslistdata.status==20">已中标</span>
                  <span class="span2" v-if="bslistdata.status==21">未中标</span>
                  <span class="span2" v-if="bslistdata.status==50">已取消</span>
                  <span class="span3">{{bslistdata.tender_service_fee}}</span>
                  <span class="span4">{{bslistdata.create_time}}</span>
                  <span class="span5"><a  class="a4" href="javascript:;"
                      @click="getdownload(bslistdata.bidding.file_code)">
                      领取中标通知书</a></span>
                </li>
              </ul>
            </el-tab-pane>
            <el-tab-pane label="未中标项目" name="five">
              <p class="bsxt-p2"><span class="span1">领取编号</span><span class="span11">项目名称</span><span
                  class="span2">领取状态</span><span class="span3">服务费</span><span class="span4">领取时间</span><span
                  class="span5">操作</span></p>
              <ul class="bsxt-ul2">
                <li v-for="(bslistdata,index) in bslistdata5" :key="index">
                  <span class="span1">{{bslistdata.order_sn}}</span>
                  <span class="span11">{{bslistdata.project_name}}</span>
                  <span class="span2" v-if="bslistdata.status==5">待付款</span>
                  <span class="span2" v-if="bslistdata.status==10">已报名</span>
                  <span class="span2" v-if="bslistdata.status==15">待审核</span>
                  <span class="span2" v-if="bslistdata.status==20">已中标</span>
                  <span class="span2" v-if="bslistdata.status==21">未中标</span>
                  <span class="span2" v-if="bslistdata.status==50">已取消</span>
                  <span class="span3">{{bslistdata.tender_service_fee}}</span>
                  <span class="span4">{{bslistdata.create_time}}</span>
                  <span class="span5"><a href="javascript:;" @click="postorderpay(bslistdata.order_id)"></a></span>
                </li>
              </ul>
            </el-tab-pane>
            <el-tab-pane label="已取消项目" name="six">
              <p class="bsxt-p2"><span class="span1">领取编号</span><span class="span11">项目名称</span><span
                  class="span2">领取状态</span><span class="span3">服务费</span><span class="span4">领取时间</span><span
                  class="span5">操作</span></p>
              <ul class="bsxt-ul2">
                <li v-for="(bslistdata,index) in bslistdata11" :key="index">
                  <span class="span1">{{bslistdata.order_sn}}</span>
                  <span class="span11">{{bslistdata.project_name}}</span>
                  <span class="span2" v-if="bslistdata.status==5">待付款</span>
                  <span class="span2" v-if="bslistdata.status==10">已报名</span>
                  <span class="span2" v-if="bslistdata.status==15">待审核</span>
                  <span class="span2" v-if="bslistdata.status==20">已中标</span>
                  <span class="span2" v-if="bslistdata.status==21">未中标</span>
                  <span class="span2" v-if="bslistdata.status==50">已取消</span>
                  <span class="span3">{{bslistdata.tender_service_fee}}</span>
                  <span class="span4">{{bslistdata.create_time}}</span>
                  <span class="span5"><a href="javascript:;" @click="postorderpay(bslistdata.order_id,bslistdata.handler_id)">去支付</a><a
                      href="javascript:;" @click="postorderover(bslistdata.order_id)">取消领取</a></span>
                </li>
              </ul>
            </el-tab-pane>
          </el-tabs>
        </template>



      </div>
    </div>
    <!--content END-->
    <!--footer-->
    <div class="bottom">
      <div class="bot-left">
        <p class="p1">联系广智华荣</p>
        <p>电子邮箱：406223221@qq.com</p>
        <p>总机：028-61894045</p>
        <p>领取标书开放时间为工作日的9:00至17:00 </p>
        <p>公司地址：四川省成都市金牛区金周路595号</p>
      </div>
      <div class="bot-right">
        <p class="p1"> 微信订阅号：</p>
        <p class="p2"><img src="../../assets/images/wm3.png" alt=""></p>
      </div>
    </div>
    <div class="footer">
      OPYRIGHT (©) 2022 四川广智华荣工程项目咨询有限公司 备案号：<a href="https://beian.miit.gov.cn/"  target="_blank">蜀ICP备2021003450号</a>
    </div>

    <el-dialog title="微信扫码支付" :visible.sync="dialogVisible3" width="40%">
      <p class="lg-p">
        <span class="sp1">商户订单号：{{paydata.order_sn}}</span>
        <span class="sp2">订单名称：{{paydata.name}}</span>
        <span class="sp1">付款金额：服务费{{paydata.tender_service_fee}} 元</span>
        <span class="sp2">商品描述：{{paydata.project_name}} </span>
        <span class="sp3" id="qrcode" ref="qrCodeUrl"></span>
      </p>
      <p>
        若提示交易买家不匹配或无法支付,请到"我报名的项目-待付款项目"列表取消订单重新下单!或者更换成谷歌浏览器
        支付过程中请不要手动刷新或关闭支付跳转页面，
        以免购买信息更新不及时!
        支付完成后点击确认完成跳转!
      </p>
      <p slot="footer" class="dialog-footer">
        <el-divider>
          <el-button type="primary" round @click="gouser2()">完成交易</el-button>
        </el-divider>
      </p>
    </el-dialog>

    <el-dialog title="微信扫码支付" :visible.sync="dialogVisible4" width="40%">
      <p class="lg-p">
        <span class="sp1">保证金订单号：{{paydata.security_sn}}</span>
        <span class="sp2">订单名称：{{paydata.name}}</span>
        <span class="sp1">付款金额：保证金{{paydata.security}} 元</span>
        <span class="sp2">商品描述：{{paydata.project_name}} </span>
        <span class="sp3" id="qrcode" ref="qrCodeUrl"></span>
      </p>
      <p>
        若提示交易买家不匹配或无法支付,请到"我报名的项目-待付款项目"列表取消订单重新下单!或者更换成谷歌浏览器
        支付过程中请不要手动刷新或关闭支付跳转页面，
        以免购买信息更新不及时!
        支付完成后点击确认完成跳转!
      </p>
      <p slot="footer" class="dialog-footer">
        <el-divider>
          <el-button type="primary" round @click="gouser2()">完成交易</el-button>
        </el-divider>
      </p>
    </el-dialog>


    <el-dialog title="上传大文件" :visible.sync="dialogVisible5" width="50%">
      <div class="updatbig">
         <table>
             <tr class="noborder">
                 <td class="required">标书上传:</td>
                 <td class="vatop rowform">
                     <span class="type-file-box">
                         <input type="file" id="x" class='type-file-text'>
                         <input name="file_code" id="file_code" type="hidden" value="">
                         <textarea id="msg" style="width:99%;height:300px;overflow-y:auto;"></textarea>
                     </span>

                 </td>
                 <td class="vatop tips">文件限制100M以内</td>
             </tr>
             <tr>
                 <td></td>
                 <td>
                     <div id="percent-bg">
                         <span id="percent"></span>
                         <span id="percent_num">{{percent}}</span>
                     </div>
                     <div class="upda-p">
                       <span class="sp1">

                             <el-button size="medium"  @click="afterselect()">上传</el-button>
                       </span>
                       <span class="sp2">

                           <el-button size="medium"  @click="handleSuccess()">提交标书</el-button>
                       </span>
                     </div>
                 </td>
             </tr>

         </table>


      </div>

    </el-dialog>

  </div>
</template>

<script type="text/ecmascript-6">
  import http from '../../http.js';
  import QRCode from "qrcodejs2";
  import $ from 'jquery';
  export default {
    data() {
      return {
        visible: false,
        dialogVisible: false,
        dialogVisible2: false,
        dialogVisible3: false,
        dialogVisible4: false,
        dialogVisible5: false,
        activeName: 'first',
        activeName2: 'negg',
        activeName3: 'zcfg',
        input: "",
        checked: false,
        inputName: "",
        inputPassword: "",
        regnumber: 0,
        yhchecked: true,
        user_id: '',
        imageUrl: '',
        user_name: '四川久河企业',
        ruleForm: {
          username: '',
          password: '',
          checkPass: ''
        },
        formInline: {
          type: '',
          name: '',
          reg_address: '',
          company_type: '',
          taxpayer_id: '',
          business_scale: '',
          legal_phone: '',
          reg_capital: '',
          cm_linked_man: '',
          cm_linked_man_phone: '',
          estab_date: '',
          bank_number: '',
          company_tel: '',
          bank_account: '',
          billing_address: '',
          legal_repre: '',
          certificate_type: '',
          image_three: '',
          image_five: '',
        },
        radio: '1',
        bslistdata: "",
        bslistdata1: [],
        bslistdata11: "",
        bslistdata2: "",
        bslistdata3: "",
        bslistdata4: "",
        bslistdata5: "",
        bslistdata6: "",
        documents_id: "",
        bstextdata: "",
        bstype: "3",
        tableData: [],
        multipleSelection: [],
        wechatkey: "",
        order_id: "",
        qrcodeurl: "",
        paydata: "",
        documentsid:0,
        fileList1: [],
        fileList2: [],
        fileList3: [],
        fileList:[{name: 'food.jpeg', url: 'https://fuss10.elemecdn.com/3/630'}],
        pz: {
            "maxSize":1024*1024*1500, //文件大小限制100M
            "bufferSize":1024*512, //单个分片大小
            "blocks":[], //分片数据集合
            "blockName":"newfile",//表单 file 的名字
            "filename":"1.jpg",//上传的本地文件真实文件名
            "threadNum":2,//上传线程数量
            "reset":function(fname){
                this.blocks = [];
                this.filename = fname;
            }

        },
        updturl:'',
        pindex : 0,
        activeThreadCount : 0, //当前活跃线程数量
        sendedBlockCount : 0, //已上传的block数量
        percent:0//已上传的百分比

      }
    },
    mounted: function() {
      this.getbslist(1);
      this.getbslist(11);
      this.getbslist(2);
      this.getbslist(3);
      this.getbslist(4);
      this.getbslist(5);
      this.getbslist(6);

      var user_id = sessionStorage.getItem("user_id");
      if (user_id != undefined) {
        this.user_id = sessionStorage.getItem("user_id");
        this.user_name =sessionStorage.getItem("user_name");
      }

    },
    methods: {

      handleClose(done) {
        done();
      },
      getDocumentsid(index){

        this.dialogVisible5 = true;
        console.log(513);
        console.log(index);
        this.documentsid = index;
      },

    afterselect(){
        console.log(12313);
          var that =this;
          var __index=0;
          var __activeThreadCount = 0; //当前活跃线程数量
          var __sendedBlockCount = 0; //已上传的block数量
          var pz =this.pz;
          this.pindex=0;
          this.activeThreadCount=0;
          this.sendedBlockCount=0;
          this.percent=0;


          if(document.getElementById("x").files.length<1){
              return false;
          }
          var file = document.getElementById("x").files[0];
          if(file.size>pz.maxSize){
              this.showmsg("文件大小限制："+pz.maxSize+"，实际文件大小："+file.size);
              return;
          }
          pz.reset(file.name);

          __index = __activeThreadCount = __sendedBlockCount = 0;

          var endByte = 0,startByte = 0;

          while(true){
              startByte = endByte;
              if(endByte + pz.bufferSize >= file.size){
                  endByte = file.size;
              }else{
                  endByte = endByte+pz.bufferSize;
              }
              var block = this.sliceFile(file,startByte,endByte);
              if(!block){
                  this.showmsg("分片失败");
                  return;
              }
              pz.blocks.push(block);
              if(endByte >= file.size){ break; }
          }
          this.showmsg("文件名："+file.name);
          this.showmsg("文件大小："+file.size);
          this.showmsg("总分片数量："+this.pz.blocks.length);
          console.log("js3")

          var dis = Math.min(this.pz.threadNum,this.pz.blocks.length);
          for(var i=0;i<dis;i++){
              (function(i){
                  setTimeout(function(){
                      __activeThreadCount++;
                      that.fenpei(i);
                  },500);
              })(i);
          }
          this.showmsg("启动线程："+dis+" 个");
          this.showmsg("------------------------");
      },

     fenpei(i){
       var __index =this.pindex;
       var __activeThreadCount = this.activeThreadCount;
        var pz =this.pz;
          //参数:线程名
          if(__index>=pz.blocks.length){
              this.showmsg("线程"+i+' 结束');
              this.activeThreadCount=__activeThreadCount-1;
              if(__activeThreadCount==0){
                  this.showmsg("------------------------");
                  this.showmsg('多线程分片上传完毕，正在处理分片数据...');
                  this.combineFile();
              }
              return;
          }
          this.uploadBlock(i,__index);
            this.pindex=__index+1;
      },

     combineFile(){
       var that =this;
       var pz =this.pz;
          $.post(
              "http://api.scgzzx.cn/api/upload/up_video?hlf=1",
              {"act":"combine","location":"12","chunks":pz.blocks.length,"filename":pz.filename},
              function(e){
                  if(e.data.flag){
                    console.log(2112);
                      that.showmsg("分片数据处理完成，任务结束");
                      console.log(e.data.url);
                      $("#file_code").val(e.data.url);
                      that.updturl=e.data.url;
                  }else{
                    console.log(3113);
                     that.showmsg(e.data.info);
                  }
              },'json'
          );

      },
      //显示进度
       showPercent(){
         var pz =this.pz;
          var __sendedBlockCount = this.sendedBlockCount;
          this.percent = parseInt(__sendedBlockCount / pz.blocks.length *100);
          if(this.percent>100){ this.percent = 100; }
         console.log("__sendedBlockCount="+__sendedBlockCount);
          console.log("pz.blocks.length="+pz.blocks.length);
          $("#percent").stop(true,true).animate({"width":this.percent+"%"},10);
          $("#percent_num").html(this.percent+"%");

      },
      //上传一个分片
     uploadBlock(i,index){
         var that=this;
         var pz =this.pz;
          var __sendedBlockCount = this.sendedBlockCount;
          var chunk = index;
          this.showmsg('线程'+i+' 分片'+chunk+' start');
          var fd = new FormData();
          fd.append("newfile", pz.blocks[chunk]);//文件
          fd.append("filename", pz.filename);//文件名
          fd.append("chunk", chunk);//分片索引
          fd.append("chunks", pz.blocks.length);//分片总数
          $.ajax({
              url:"http://api.scgzzx.cn/api/upload/up_video",
              type:"post",
              data: fd,
              dataType:"json",
              cache: false,
              contentType:false,
              processData:false,//设置为true的时候,jquery ajax 提交的时候不会序列化 data，而是直接使用data
              success:function(data){
                  //timer线程中的异步，此时同步了
                  that.showmsg("线程"+i+" 分片"+chunk+" end");
                  that.sendedBlockCount++;
                  that.showPercent();
                  that.fenpei(i);
              },
              complete:function(XMLHttpRequest,textStatus){
              },
              error:function(){}
          });
      },
      //分割file成分片
     sliceFile(file,startByte,endByte){
          if(file.slice){
              return  file.slice(startByte,endByte);
          }
          if(file.webkitSlice){
              return  file.webkitSlice(startByte,endByte);
          }
          if(file.mozSlice){
              return  file.mozSlice(startByte,endByte);
          }
          return null;
      },
      //输出消息
     showmsg(msg){
          var _t = $("#msg").val();
          _t += msg+"\r\n";
          $("#msg").val(_t);
          var scrollTop = $("#msg")[0].scrollHeight;
          $("#msg").scrollTop(scrollTop);
      },


 ///提交文件地址
      handleSuccess() {
         var that =this;
        console.log(this.updturl);
         if(this.updturl==''){
           this.$message.error('先上传文件');
           return;
         }
          var parameter = {
            id: this.documentsid,
            fileupload: this.updturl,
          };

          this.$axios.post(this.conf.base_url + "/api/upload/fileupload",  parameter).then(res => {
            if (res.data.code != "0") {
              that.$message.error('访问错误');
            } else {
              console.log(res.data);
              that.formInline.image_three=res.data.result;
              that.pindex=0;
              that.activeThreadCount=0;
              that.sendedBlockCount=0;
              that.percent=0;
              that.dialogVisible5 = false;
               that.$message.success('文件上传成功!');
                this.$router.go(0);
            }
          })

      },


      /*选择标号*/
      handleSelectionChange(val) {
        this.multipleSelection = val;
        console.log(this.multipleSelection);
      },
      gouser2() {
        this.$router.go(0);
      },
      /*获取供应商联系人id*/

      /*提交订单支付服务费*/
      postorderpay(i,a) {
        var that = this;
        console.log(i);
        var parameter = {
          order_id: i,
          handler_id: a,
          wechatkey: sessionStorage.getItem("key"),
        };
        http.post(this.conf.base_url + '/api/order/submit', parameter).then(res => {
          if (res.data.code != "0") {
            this.$message.error(res.data.msg);
          } else {
            this.dialogVisible3 = true;
            console.log(res.data.result);
            that.paydata = res.data.result;
            setTimeout(function() {
              that.creatQrCode(res.data.result.qrcode);

            }, 100);

          }
        }).catch(e => {
          //..
        })
      },
      /*提交订单支付保证金*/
      postorderpay2(i) {
        var that = this;
        console.log(i);
        var parameter = {
          order_id: i,
          wechatkey: sessionStorage.getItem("key"),
        };
        http.post(this.conf.base_url + '/api/order/security', parameter).then(res => {
          if (res.data.code != "0") {
            this.$message.error(res.data.msg);
          } else {
            if (res.data.result == undefined) {
              that.$message.success('支付保证金成功!');
              that.$router.go(0);
            } else {
              this.dialogVisible4 = true;
              console.log(res.data.result);
              that.paydata = res.data.result;
              setTimeout(function() {
                that.creatQrCode(res.data.result.qrcode);
              }, 100);
            }


          }
        }).catch(e => {
          //..
        })
      },
      /*提交获取二维码*/
      creatQrCode(i) {
        const codeHtml = document.getElementById("qrcode");
        codeHtml.innerHTML = "";
        let a = new QRCode(this.$refs.qrCodeUrl, {
          text: i, // 需要转换为二维码的内容
          width: 200,
          height: 200,
          colorDark: "black", //#000000为黑色
          colorLight: "white",
        });
        console.log(i);

      },
      postorderover(i) {
        var that = this;
        this.$confirm('确定要取消此订单?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.postordercancel(i);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消订单'
          });
        });
      },

      /*提交取消订单*/
      postordercancel(i) {
        var that = this;
        console.log(i);
        var parameter = {
          order_id: i,
          wechatkey: sessionStorage.getItem("key"),
        };
        http.post(this.conf.base_url + '/api/order/cancel', parameter).then(res => {
          if (res.data.code != "0") {
            this.$message.error(res.data.msg);
          } else {
            console.log(res.data.result);
            that.$message.success('取消成功!');
            that.$router.go(0);
          }
        }).catch(e => {
          //..
        })
      },
      /*下载文件*/
      getdownload(e) {
        console.log(e)
        if(e==""){
           this.$message.info('暂无链接文件');
        }else if(e==null){
           this.$message.info('下载文件为空');
        }
        else{
          window.open(e, '_blank');
        }
      },

      /*标书跳转*/
      getbstextdata() {
        var that = this;
        var parameter = {
          id: this.documents_id
        };
        http.post(this.conf.base_url + '/api/documents/details', parameter).then(res => {
          if (res.data.code != "0") {
            this.$message.error(res.data.msg);
          } else {
            console.log(res.data.result);
            this.bstextdata = res.data.result;
            this.activeName = 'first',
              this.bstype = 2;
            this.tableData = res.data.result.sub;
          }
        }).catch(e => {
          //..
        })


      },
      /*获取标书信息*/
      getbslist(i) {
        var that = this;
        this.bstype = "1";
        var parameter = {};
        var bslistdata0 =[];
        var bslistdata11 = [];
        if (i == 1) {
          var parameter = {
            wechatkey: sessionStorage.getItem("key"),
            status: 5,
          }
        } else if (i == 11) {
          var parameter = {
            wechatkey: sessionStorage.getItem("key"),
            status: 0,
          }
        } else if (i == 2) {
          var parameter = {
            wechatkey: sessionStorage.getItem("key"),
            status: 10
          }
        } else if (i == 3) {
          var parameter = {
            wechatkey: sessionStorage.getItem("key"),
            status: 15
          }
        } else if (i == 4) {
          var parameter = {
            wechatkey: sessionStorage.getItem("key"),
            status: 20
          }
        } else if (i == 5) {
          var parameter = {
            wechatkey: sessionStorage.getItem("key"),
            status: 21
          }
        } else if (i == 6) {
          var parameter = {
            wechatkey: sessionStorage.getItem("key"),
            status: 50
          }
        }
        http.post(this.conf.base_url + '/api/order/index', parameter).then(res => {
          if (res.data.code != "0") {
            this.$message.error(res.data.msg);
          } else {
            var bslistdata0 =[];
            var bslistdata11 =[];
            if (i == 1) {
              this.bslistdata1 = res.data.result.list;
              console.log(111);
            }
            if (i == 11) {
             this.bslistdata11 = res.data.result.list;
              console.log(111111);
               console.log(that.bslistdata11)
            }
            if (i == 2) {
              this.bslistdata2 = res.data.result.list;
               console.log(222);
            }
            if (i == 3) {
              this.bslistdata3 = res.data.result.list;
              console.log(333);
            }
            if (i == 4) {
              this.bslistdata4 = res.data.result.list;
              console.log(444);
            }
            if (i == 5) {
              this.bslistdata5 = res.data.result.list;
               console.log(55);
            }
            if (i == 6) {
              this.bslistdata6 = res.data.result.list;
            }



          }
        }).catch(e => {
          //..
        })
      },



      /*图片上传*/
      handleAvatarSuccess(res, file) {
        this.formInline.image_five = URL.createObjectURL(file.raw);
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
      /*登录*/
      postLogin() {
        console.log(this.conf.base_url);

        var that = this;
        var parameter = {
          user_name: this.inputName,
          password: this.inputPassword
        }
        http.post(this.conf.base_url + '/api/login/login', parameter).then(res => {
          if (res.data.code != "0") {
            this.$message.error('访问错误');
          } else {
            console.log(res.data);
            sessionStorage.setItem("key", res.data.result.key);
            sessionStorage.setItem("user_id", res.data.result.user_id);
            sessionStorage.setItem("user_name", res.data.result.user_name);
            this.$router.go(0);

          }
        }).catch(e => {
          //..
        })
      },
      gologinout() {
        sessionStorage.clear();
        // this.$router.go(0);
        this.gobsxt();
      },
      goqyxx: function() {
        this.$router.push({
          path: '/qyxx/'
        });
      },
      handleClick(tab, event) {
        this.bstype = 1;
        console.log(333333333);
      },

      goHome: function() {
        this.$router.push({
          path: '/index/'
        });
      },
      gogsdt: function() {
        this.$router.push({
          path: '/gsdt/'
        });
      },
      gojlyd: function() {
        this.$router.push({
          path: '/jlyd/'
        });
      },
      gokffw: function() {
        this.$router.push({
          path: '/kffw/'
        });
      },
      goqyjj: function() {
        this.$router.push({
          path: '/qyjj/'
        });
      },
      gorczp: function() {
        this.$router.push({
          path: '/rczp/'
        });
      },
      gozbxx: function() {
        this.$router.push({
          path: '/zbxx/'
        });
      },
      gouser: function() {
        this.$router.push({
          path: '/user/'
        });
      },
      gobsxt: function() {
        this.$router.push({
          path: '/bsxt/'
        });
      },
      gonewstxt: function() {
        this.$router.push({
          path: '/newstxt/'
        });
      },

    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/user.vue